

























































import { Prop, Vue, Component } from "vue-property-decorator";
import { PageModule } from "@/store/module/page";
import { dateFormat } from "@/utils/timeFormat";
@Component
export default class extends Vue {
  @Prop(String) rangeType!: string; // 只有传all时会显示月周日的切换按钮
  @Prop(String) weekStartDay?: string; // 周的开始日期，1为周一，7为周日
  currentRangeStart: number = 0;
  currentRangeEnd: number = 0;
  currentType: string = "";
  isCurrent: boolean = true;
  cacheDate: any = {};
  week_value = "";
  created() {
    this.currentType = this.rangeType === "all" ? "month" : this.rangeType; //传all时默认为月
    const now = new Date();
    this.currentRangeStart = this.getStartTime(now); //获取当前时间段的开始
    this.currentRangeEnd = this.getEndTime(now); //获取当前时间段的结束
    const teacher = PageModule.pageInfo.teacherStoreDate;
    if (teacher.teacherTime) {
      this.currentRangeStart = teacher.teacherTime.startDate;
      this.currentRangeEnd = teacher.teacherTime.endDate;
      const cur: number = new Date().getTime();
      if (this.currentRangeStart <= cur && this.currentRangeEnd >= cur) {
        this.isCurrent = true;
      } else {
        this.isCurrent = false;
      }
      this.$emit("switch", [
        teacher.teacherTime.startDate,
        teacher.teacherTime.endDate,
      ]);
    } else {
      this.handleCurrent("");
    }
    this.week_value = dateFormat(
      "YYYY-mm-dd",
      new Date(this.currentRangeStart).getTime()
    );
  }
  // 时间选择, 把时间组件隐藏,处理时间
  handleChangeTime(v: any) {
    if (this.currentType === "week") {
      this.currentRangeStart =
        new Date(this.week_value).getTime() + 6 * 24 * 3600 * 1000;
      this.currentRangeEnd =
        new Date(this.week_value).getTime() + 12 * 24 * 3600 * 1000;
    }
    this.handlePrev();
  }
  format(v: number) {
    const cur = new Date(v);
    return `${cur.getFullYear()}年${cur.getMonth() + 1}月${cur.getDate()}日`;
  }
  getStartTime(v: Date) {
    let str = "";
    if (this.currentType === "month") {
      // 找1号
      str = `${v.getFullYear()}-${v.getMonth() + 1}-1 00:00:00`;
    } else if (this.currentType === "week") {
      let startDay: Date;
      if (this.weekStartDay === "1") {
        // 找周一
        startDay = new Date(
          v.getTime() -
            (v.getDay() === 0 ? 6 : v.getDay() - 1) * 24 * 60 * 60 * 1000
        );
      } else {
        // 找周日
        startDay = new Date(v.getTime() - v.getDay() * 24 * 60 * 60 * 1000);
      }
      str = `${startDay.getFullYear()}/${
        startDay.getMonth() + 1
      }/${startDay.getDate()} 00:00:00`;
    } else if (this.currentType === "day") {
      // 找当天0点
      str = `${v.getFullYear()}/${v.getMonth() + 1}/${v.getDate()} 00:00:00`;
    }
    const res = new Date(str).getTime();
    return res;
  }
  getEndTime(v: Date) {
    let str = "";
    if (this.currentType === "month") {
      // 找当月最后一日
      let m = v.getMonth();
      let y = v.getFullYear();
      if (m === 11) {
        m = 1;
        y = y + 1;
      } else {
        m = m + 2;
      }
      const next = new Date(
        new Date(`${y}/${m}/1`).getTime() - 24 * 60 * 60 * 1000
      );
      str = `${next.getFullYear()}-${
        next.getMonth() + 1
      }-${next.getDate()} 23:39:39`;
    } else if (this.currentType === "week") {
      let endDay: Date;
      if (this.weekStartDay === "1") {
        // 找周日
        endDay = new Date(
          v.getTime() +
            (v.getDay() === 0 ? 0 : 7 - v.getDay()) * 24 * 60 * 60 * 1000
        );
      } else {
        // 找周六
        endDay = new Date(v.getTime() + (6 - v.getDay()) * 24 * 60 * 60 * 1000);
      }
      str = `${endDay.getFullYear()}/${
        endDay.getMonth() + 1
      }/${endDay.getDate()} 23:39:39`;
    } else if (this.currentType === "day") {
      // 找当天24点
      str = `${v.getFullYear()}/${v.getMonth() + 1}/${v.getDate()} 23:39:39`;
    }
    const res = new Date(str).getTime();
    return res;
  }
  handleCurrent(v: any) {
    const now = new Date();
    const start = this.getStartTime(now);
    const end = this.getEndTime(now);
    this.currentRangeStart = start;
    this.currentRangeEnd = end;
    this.$emit("switch", [start, end]);
    this.isCurrent = true;
    if (v === "click") {
      this.setWeekTime();
    }
    this.week_value = dateFormat(
      "YYYY-mm-dd",
      new Date(this.currentRangeStart).getTime()
    );
  }
  handlePrev() {
    const now = new Date(this.currentRangeStart);
    let target = new Date();
    if (this.currentType === "month") {
      let m = now.getMonth();
      let y = now.getFullYear();
      if (m === 0) {
        m = 12;
        y = y - 1;
      }
      target = new Date(`${y}/${m}/1`);
    } else if (this.currentType === "week") {
      target = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
    } else if (this.currentType === "day") {
      target = new Date(now.getTime() - 24 * 60 * 60 * 1000);
    }
    const start = this.getStartTime(target);
    const end = this.getEndTime(target);
    this.currentRangeStart = start;
    this.currentRangeEnd = end;
    this.$emit("switch", [start, end]);
    const cur: number = new Date().getTime();
    if (start <= cur && end >= cur) {
      this.isCurrent = true;
    } else {
      this.isCurrent = false;
    }
    this.setWeekTime();
    this.week_value = dateFormat(
      "YYYY-mm-dd",
      new Date(this.currentRangeStart).getTime()
    );
  }
  setWeekTime() {
    this.cacheDate.startDate = this.currentRangeStart;
    this.cacheDate.endDate = this.currentRangeEnd;
    this.cacheDate.type = this.rangeType;
    this.cacheDate.morword = this.currentType;
    PageModule.SET_PAGE_INFO({
      name: "teacherStoreDate",
      key: "teacherTime",
      value: this.cacheDate,
    });
  }
  handleNext() {
    const now = new Date(this.currentRangeStart);
    let target = new Date();
    if (this.currentType === "month") {
      let m = now.getMonth();
      let y = now.getFullYear();
      if (m === 11) {
        m = 1;
        y = y + 1;
      } else {
        m = m + 2;
      }
      target = new Date(`${y}/${m}/1`);
    } else if (this.currentType === "week") {
      target = new Date(now.getTime() + 7 * 24 * 60 * 60 * 1000);
    } else if (this.currentType === "day") {
      target = new Date(now.getTime() + 24 * 60 * 60 * 1000);
    }
    const start = this.getStartTime(target);
    const end = this.getEndTime(target);
    this.currentRangeStart = start;
    this.currentRangeEnd = end;
    this.$emit("switch", [start, end]);
    const cur: number = new Date().getTime();
    if (start <= cur && end >= cur) {
      this.isCurrent = true;
    } else {
      this.isCurrent = false;
    }
    this.setWeekTime();
    this.week_value = dateFormat(
      "YYYY-mm-dd",
      new Date(this.currentRangeStart).getTime()
    );
  }
  handleTypeChange(e: string) {
    this.handleCurrent("");
  }
}
